import SseHub from './SseHub.js';

// Cliente SSE para el cronograma de la generación de reglas de auditoría de un formato.
//
// Singleton de módulo, como el resto de canales: la suscripción sobrevive a la navegación, así
// que el barrido se sigue narrando aunque quien lo lanzó se haya ido a otra pantalla, y al
// volver al formato el hub reenvía el último evento del canal — que es exactamente el estado
// al día del cronograma.
//
// El canal es de difusión y por él pasan las pasadas de TODOS los formatos: cada suscriptor
// filtra por el suyo. Aquí no se filtra nada para no tener que saber de formatos.

const subscribers = [];
let enganchado = false;
const CANAL = 'generacion-reglas';
let f7ref = null;
// Última narración por formato: quien entra en un formato con una pasada en marcha pinta el
// cronograma al instante, sin esperar a que termine la sección que esté en curso.
const ultimoPorFormato = {};

function notify(payload) {
    subscribers.slice().forEach(function (cb) {
        try { cb(payload); } catch (err) { console.error('GeneracionReglasEvents subscriber threw', err); }
    });
}

function toastGlobal(texto) {
    try {
        if (f7ref && f7ref.toast) {
            f7ref.toast.create({ text: texto, closeTimeout: 6000, closeButton: true }).open();
        }
    } catch (e) {}
}

function onEvento(evento) {
    let payload = evento;
    if (typeof evento === 'string') {
        try { payload = JSON.parse(evento); } catch (err) { payload = evento; }
    }
    if (!payload || typeof payload !== 'object') return;

    if (payload.formatoId) {
        ultimoPorFormato[payload.formatoId] = payload;
    }

    // Los eventos terminales se avisan globalmente: el barrido dura minutos y lo normal es
    // haberse ido a otra cosa mientras corre.
    const codigo = payload.formatoCodigo ? ' (' + payload.formatoCodigo + ')' : '';
    if (payload.estado === 'fin') {
        toastGlobal('🧠 Reglas generadas' + codigo + ' — ' + (payload.texto || ''));
    } else if (payload.estado === 'error') {
        toastGlobal('⚠️ Generación de reglas' + codigo + ' — ' + (payload.texto || 'Error en la pasada.'));
    } else if (payload.estado === 'cancelado') {
        toastGlobal('Generación de reglas cancelada' + codigo + '.');
    }

    notify(payload);
}

function ensureConnected() {
    if (enganchado) return;
    enganchado = true;
    SseHub.subscribe(CANAL, onEvento);
}

export default {
    /** Suscribe un callback a la narración. Pasa f7 para poder avisar globalmente. */
    subscribe(callback, f7) {
        if (f7) f7ref = f7;
        if (typeof callback === 'function' && subscribers.indexOf(callback) < 0) {
            subscribers.push(callback);
        }
        ensureConnected();
    },
    unsubscribe(callback) {
        const i = subscribers.indexOf(callback);
        if (i >= 0) subscribers.splice(i, 1);
        // La conexión NO se cierra al quedarse sin suscriptores de pantalla: mientras haya una
        // pasada en marcha interesa seguir recibiendo su fin para avisar. Es el hub quien
        // gestiona la conexión única, y cerrarla aquí cortaría también a los demás canales.
    },
    /** Última narración conocida de un formato, para pintar sin esperar al siguiente evento. */
    ultimoDe(idFormato) {
        return ultimoPorFormato[idFormato] || null;
    }
};
